import { Input, Tooltip } from "antd";
import { Droppable } from "react-beautiful-dnd";
import styles from "./Term.module.css";
import Loading from "../Loading/Loading";
import { memo, useEffect, useState } from "react";
const Term = ({
  id,
  termTitle,
  termTitleOnChange,
  isFetchedData,
  children,
  flagCount = 0,
}) => {
  const [title, setTitle] = useState(termTitle);
  useEffect(() => {
    setTitle(termTitle);
  }, [termTitle]);
  return (
    <Droppable droppableId={id}>
      {(provided) => {
        return (
          <div className={styles.Term}>
            <Input
              suffix={
                <Tooltip title="تعداد کارت ها">
                  <div>{flagCount}</div>
                </Tooltip>
              }
              size="large"
              onBlur={(val) => {
                termTitleOnChange(val.target.value);
              }}
              onChange={(val) => {
                setTitle(val.target.value);
              }}
              value={title}
              className={styles.Input}
              placeholder="بازه زمانی را وارد کنید:"
            />

            {isFetchedData === false ? <Loading /> : null}
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={styles.TermContent}
            >
              {children}
              {provided.placeholder}
            </div>
          </div>
        );
      }}
    </Droppable>
  );
};
export default memo(Term);
